<p-confirmDialog key="adjust" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainBorder">
	<!--Main Details-->
	<div class="MainGrid2Col">
		<label>Student ID:</label>
		<label class="InfoText">{{ StudentID }}</label>

		<label>Student Name:</label>
		<label class="InfoText">{{ StudentName }}</label>

		<label>Item Type:</label>
		<label class="InfoText">{{ TransactionDesc }}</label>

		<label>Date/Time:</label>
		<label class="InfoText">{{ FineDT }}</label>

		<label>Administrator:</label>
		<label class="InfoText">{{ AdminName }}</label>

		<label>Original Comments:</label>
		<label class="InfoText">{{ OriginalComments }}</label>

		<label>Original Amount:</label>
		<label class="InfoText">{{ OriginalAmount }}</label>

		<label>Item Balance:</label>
		<label class="InfoText">{{ ItemBalance }}</label>

		<label>Adjustment Amount:</label>
		<!-- <p-inputNumber [min]="0" [max]="ItemBalanceNum" [(ngModel)]="AdjustAmount" (ngModelChange)="onAdjustAmountChange($event)" mode="currency" currency="USD" locale="en-US" step="0.01" [showButtons]="true"></p-inputNumber> -->
		<input
			class="form-control"
			type="number"
			[min]="0"
			[max]="ItemBalanceNum"
			step="0.01"
			[(ngModel)]="AdjustAmount"
			(ngModelChange)="onAdjustAmountChange($event)"
		/>

		<label>New Fine Balance:</label>
		<label class="InfoText">{{ NewBalanceDesc }}</label>

		<label>Adjust Comments:</label>
		<textarea class="TextArea" [(ngModel)]="AdjustComments" rows="5"></textarea>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdjust()">Adjust/Waive Fine</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
